// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import LaborAdditiveStateFacets, {getDefaultState as getFacetsDefaultState} from './facets';
import LaborAdditiveSummaries, {getDefaultState as getLaborAdditivePipsSummariesDefaultState} from './labor-additive-summaries';
import LaborAdditiveSummary, {getDefaultState as getLaborAdditivePipsSummaryDefaultState} from '@deere/cps-it.warranty-model-factory/lib/labor-additive-summary';
import PipProducts, {getDefaultState as getPipProductsDefaultState} from '../../shared/state/pip-products';
import SearchByDropDown, {getDefaultState as getSearchByDropDownDefaultState} from '../../shared/state/search-by-dropdown';
import SearchFilters from '../../../shared/state/search-filters';
import {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const LaborAdditiveState = t.struct({
    busyCounter: BusyCounter,
    facets: LaborAdditiveStateFacets,
    hasSearchResults: t.Boolean,
    isMoreSummaryVisible: t.Boolean,
    isVisible: t.Boolean,
    laborAdditiveSummaries: LaborAdditiveSummaries,
    laborAdditiveSummary: LaborAdditiveSummary,
    pipProducts: PipProducts,
    pipProductsFiltered: PipProducts,
    searchByDropDown: SearchByDropDown,
    searchFilters: SearchFilters,
    searchQueryString: t.String
}, 'LaborAdditiveState');

export const getDefaultState = () => new LaborAdditiveState({
    busyCounter: getBusyCounterDefaultState(),
    facets: getFacetsDefaultState(),
    hasSearchResults: false,
    isMoreSummaryVisible: false,
    isVisible: false,
    laborAdditiveSummaries: getLaborAdditivePipsSummariesDefaultState(),
    laborAdditiveSummary: getLaborAdditivePipsSummaryDefaultState(),
    pipProducts: getPipProductsDefaultState(),
    pipProductsFiltered: getPipProductsDefaultState(),
    searchByDropDown: getSearchByDropDownDefaultState(),
    searchFilters: getSearchFiltersDefaultState(),
    searchQueryString: ''
});

export default LaborAdditiveState;



// WEBPACK FOOTER //
// ./src/pip/labor-additive/state/index.js